/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export function buildFormData(data: Record<string, unknown>): FormData {
	const formData = new FormData()
	for (const [key, value] of Object.entries(data)) {
		if (value instanceof File || value instanceof Blob) {
			formData.append(key, value)
		} else if (Array.isArray(value)) {
			// PHP-style array fields: websites[]=a&websites[]=b parses to an array.
			for (const item of value) {
				if (item instanceof File || item instanceof Blob) {
					formData.append(`${key}[]`, item)
				} else if (item != null) {
					formData.append(`${key}[]`, String(item))
				}
			}
		} else if (value != null) {
			formData.append(key, String(value))
		}
	}
	return formData
}
